// components/NdsCell.js
import {memo} from "react";

export const NdsCell = memo(({nds}) => (
    nds > 0 ? (
        <span style={{
            fontSize: '13px',
            color: '#fa541c',
            backgroundColor: '#fff2e8',
            padding: '2px 6px',
            borderRadius: '2px'
        }}>
            {nds}%
        </span>
    ) : (
        <span style={{fontSize: '13px', color: '#bfbfbf'}}>—</span>
    )
));

NdsCell.displayName = 'NdsCell';